import React from 'react'
import { useRecoilValue } from 'recoil'
import styled from 'styled-components'
import { themeState } from '../../../../recoil/states/default'
import { hexToRgba } from '../../../../utils/hexToRgba'
import Carousel from './carousel'
import bg_cord from '../../../../assets/images/home/bg_cord.jpg'

const JobDetailCarousel = (props) => {
    const { job } = props
    const theme = useRecoilValue(themeState)
    const bg = bg_cord//'https://redcross.or.th/wp-content/uploads/2017/10/BG_cord.jpg?id=128'
    const Banner = styled.div`
        background: linear-gradient(0deg, ${hexToRgba(theme.primary)}, ${hexToRgba(theme.primary)}), url(${bg});
        object-fit: cover;
        background-size: cover;
    `

    const isMobile = window.innerWidth <= 992

    return (
        <>
            {isMobile &&
                <>
                    <div className="title-mobile px-3 py-2">
                        <div className="title">งานที่คล้ายกัน</div>
                    </div>
                </>}
            <Banner className='div-job-detail-carousel'>
                {!isMobile && <div className="container margin-auto div-title flex justify-between items-center px-3">
                    <div className="title">งานที่คล้ายกัน</div>
                </div>}
                <div className="div-carousel relative">
                    <Carousel job={job} />
                </div>
            </Banner>
        </>
    )
}

export default JobDetailCarousel